import {HTTP, ERROR} from '@/http-common';
import Vue from 'vue';

const state = {
  messagesFor: null,
  messages: [],
  replyPhone: '',
  body: '',
  loading: false
}

const mutations = {
  SET_MESSAGES(state, data) {
    state.messages = data.messages
    state.replyPhone = data.replyPhone
  },
  SUBMIT_MESSAGES_MESSAGE_SUCCESS(state, data) {
    // Date comes in wrong format - dont use it
    state.messages.push(data.message) // @TODO dispatch getMessages... or return all messages from api
  }
}

const getters = {
  getMessages: state => state.messages,
  getReplyPhone: state => state.replyPhone
}

const actions = {
  GET_MESSAGES_ACTION: ({commit}, payload) => {
    state.loading = true;
    if(payload.button != null)
      payload.button.start();
    if(payload.id != state.messagesFor)
      state.messages = [];

    HTTP.post(`messages`, {participant_id: payload.id, search: payload.search})
      .then(response => {
        ERROR(response)
        if (response.data.status === 'success') {
          state.messagesFor = payload.id;
          commit('SET_MESSAGES', response.data.data);
          state.loading = false
          if(payload.button != null)
            payload.button.stop();
        }
      })
      .catch(err => {
        console.log(err);
        state.loading = false
        if(payload.button != null)
          payload.button.stop();
      })
  },
  SUBMIT_MESSAGES_MESSAGE_ACTION: ({commit, dispatch}, payload) => {
    state.loading = true;
    payload.button.start();

    return HTTP.post(`messages/send`, {participant_id: payload.id, body: payload.body})
      .then(response => {
        if(response.data.status === 'success') {
          // commit('SUBMIT_MESSAGES_MESSAGE_SUCCESS', response.data.data);
          Vue.prototype.$notify('SMS sent.');
          state.loading = false;
        } else {
          dispatch('GET_MESSAGES_ACTION', {id: payload.id});
          Vue.prototype.$notify({type: 'error', text: response.data.message});
          state.loading = false
        }
        payload.button.stop();
      })
      .catch(err => {
        console.log(err);
        payload.button.stop();
        state.loading = false
      })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/messages.js